import { Component } from '@angular/core';

@Component({
  selector: 'app-p403',
  standalone: false,
  templateUrl: '403.component.html'
})
export class P403Component {

  constructor() { }

}
